import helper from 'helpers/steinerHelper';
import client from 'apis/apiMarketingSuite';
import { normalizzaInterazionePerSlot } from 'helpers/interazioniSlotHelper';

const paramsMap = {
    titolo: 'q',
    per_page: 'perPage',
    page: 'page',
    sort_field: 'orderKey',
    sort_direction: 'orderDirection',
    ao_hotel_id: 'ao_hotel_id',
    stato_online: 'expiration',
};

const apis = helper.createApi('interazioni', client, paramsMap);

apis.aggiornaInterazione = (interazioneId, data) => {
    return client({
        url: `interazioni/${interazioneId}`,
        method: 'patch',
        data: data,
    });
};

apis.attivaInterazione = (interazioneId, value) => {
    return client({
        url: `interazioni/${interazioneId}/online`,
        method: 'post',
        data: { stato_online: value },
    });
};

apis.clonaInterazione = (interazioneId) => {
    return client({
        url: `interazioni/${interazioneId}/clona`,
        method: 'post',
    });
};

apis.dettaglioInterazione = (interazioneId) => {
    return client({
        url: `interazioni/${interazioneId}`,
        method: 'get',
    });
};

apis.fetchPagine = (hotelId) => {
    return client({
        url: `pagine?ao_hotel_id=${hotelId}`,
        method: 'get',
    });
};

apis.fetchClusters = (hotelId) => {
    return client({
        url: `clusters?ao_hotel_id=${hotelId}`,
        method: 'get',
    });
};

apis.fetchLayouts = (tipoComunicazione) => {
    return client({
        url: `layouts/${tipoComunicazione}`,
        method: 'get',
    });
};

apis.fetchInterazioniOnline = (hotelId) => {
    return client({
        url: 'interazioni',
        method: 'get',
        params: {
            ao_hotel_id: hotelId,
            stato_online: true,
            per_page: 100,
            page: 1,
        },
    });
};

apis.fetchInterazioniOnlinePerSlot = (hotelId) => {
    if (!hotelId) {
        return Promise.resolve([]);
    }

    return apis.fetchInterazioniOnline(hotelId).then((res) => {
        const items = (res.data && res.data.data) || [];

        return Promise.all(
            items.map((item) => {
                const normalizzata = normalizzaInterazionePerSlot(item);

                if (normalizzata && normalizzata.tipoComunicazione) {
                    return normalizzata;
                }

                return apis
                    .dettaglioInterazione(item.id)
                    .then((dettaglio) =>
                        normalizzaInterazionePerSlot(dettaglio.data)
                    );
            })
        ).then((interazioni) => interazioni.filter(Boolean));
    });
};

export default apis;
